import { useEffect, useRef } from 'react'
import classnames from 'classnames'
import { observer } from 'mobx-react-lite'
import { SpinnerLoader } from 'shared/ui/Loader'
import { Scrollbar, type IScrollbarsPropsRef } from 'shared/ui/Scrollbar'
import { Typography } from 'shared/ui'
import { useBlockerAndUnload } from 'shared/ui/Blocker'
import { UnifiedMessageField } from 'pages/chatbot/ui/UnifiedMessageField/UnifiedMessageField'
import { useUnifiedAgentContext } from 'pages/chatbot/ui/UnifiedAgent/context/unifiedAgentContext'
import { Widgets } from './ui/Widgets/Widgets'
import { Messages } from './ui/Messages/Messages'
import styles from './styles.module.scss'

export const Chat = observer(() => {
  const { chatStore, blockerStore } = useUnifiedAgentContext()
  const {
    messages,
    isLoading,
    widget,
    inputValue,
    setInputValue,
    sendMessage,
    hasMessages,
    retry,
    isLoadingHistory,
    allMergeFields,
  } = chatStore
  const scrollbarRef = useRef<IScrollbarsPropsRef>(null)
  useBlockerAndUnload(blockerStore)

  useEffect(() => {
    scrollbarRef.current?.scrollToBottom()
  }, [messages.length, isLoading])

  const isSuggestions = widget && widget.id === 'suggestions'

  return (
    <div className={styles.wrap}>
      {isLoadingHistory ? (
        <SpinnerLoader ariaLabel={'Loading history'} />
      ) : (
        <Scrollbar ref={scrollbarRef}>
          <div className={styles.scrollContent}>
            {hasMessages && (
              <div className={styles.messagesWrap}>
                <Messages
                  messages={messages}
                  retry={retry}
                  setInputValue={setInputValue}
                  allMergeFields={allMergeFields}
                />
                {isLoading && (
                  <div className={styles.aiBubble}>
                    <SpinnerLoader
                      size={10}
                      ariaLabel={'Chat'}
                      indeterminatecolor={'var(--purple-70)'}
                    />
                    <Typography variant={'body-sm-medium'} ariaLabel={'Thinking'}>
                      Thinking...
                    </Typography>
                  </div>
                )}
              </div>
            )}
            <div
              className={classnames(styles.inputWrap, {
                [styles.widgetsWrap]: widget && !isSuggestions,
              })}
            >
              {widget && !isSuggestions ? (
                <Widgets widgetId={widget.id} />
              ) : (
                <UnifiedMessageField
                  placeholder='What should your agent do?'
                  value={inputValue}
                  handleChange={setInputValue}
                  handleSubmit={sendMessage}
                  disabledBtn={!inputValue.trim() || isLoading}
                  disabled={isLoading && !hasMessages}
                  className={styles.messageField}
                />
              )}
            </div>
          </div>
        </Scrollbar>
      )}
    </div>
  )
})
